export const GEORGIA_TIMEZONE = 'Asia/Tbilisi';
